import { UserRoleProvider } from '@/context/UserRole/UserRoleProvider'
import { UserRoleContext } from '@/context/UserRole/UserRoleContext'
import { AuthContext } from '@/context/Auth/AuthContext'
import { Template } from '@/pages/Template'
import { Outlet } from 'react-router-dom'
import { useContext } from 'react'

export const ProtectedRoutes = () => {
  return (
    <UserRoleProvider>
      <Template>
        <ProtectedRoutesContent />
      </Template>
    </UserRoleProvider>
  )
}

const ProtectedRoutesContent = () => {
  const {isAuthenticated} = useContext(AuthContext)
  const {isAuthorized} = useContext(UserRoleContext)

  return isAuthenticated && isAuthorized ? <Outlet /> : null
}
